import { useCallback, useRef } from 'react';

export const useNextSortOrder = (items: { sortOrder: number }[]) => {
  const nextSortOrderRef = useRef(0);

  const getNextSortOrder = useCallback(
    (offset = 0) => {
      const stateMax = Math.max(0, ...items.map((item) => item.sortOrder + 1));
      if (stateMax > nextSortOrderRef.current) {
        nextSortOrderRef.current = stateMax;
      }
      const next = offset + nextSortOrderRef.current;
      nextSortOrderRef.current = next + 1;
      return next;
    },
    [items]
  );

  return getNextSortOrder;
};
